const indexItems = [
  { label: '明星恋情', tag: '热门', count: '48篇' },
  { label: '综艺爆料', tag: '更新中', count: '36篇' },
  { label: '网红八卦', tag: '热门', count: '52篇' },
  { label: '影视花边', tag: '新', count: '29篇' },
  { label: '直播趣闻', tag: '更新中', count: '41篇' },
  { label: '体育圈瓜', tag: '热门', count: '33篇' },
  { label: '国际娱乐', tag: '新', count: '25篇' },
  { label: '社会热议', tag: '爆', count: '67篇' },
  { label: '怀旧经典', tag: '精选', count: '19篇' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            主题索引
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            按主题分类的吃瓜合集，快速定位你感兴趣的瓜田专区
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#index"
              className="group flex items-center justify-between p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200/70 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="flex items-center gap-3">
                <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100/70 text-accent-600 text-xs font-bold">
                  {idx + 1}
                </span>
                <div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {item.label}
                  </h3>
                  <span className="text-xs text-foreground-500">{item.count}</span>
                </div>
              </div>
              <span
                className={`inline-block px-2 py-0.5 rounded-md text-xs font-semibold whitespace-nowrap ${
                  item.tag === '爆'
                    ? 'bg-primary-100 text-primary-600'
                    : item.tag === '热门'
                      ? 'bg-accent-100 text-accent-600'
                      : item.tag === '新'
                        ? 'bg-secondary-200 text-secondary-700'
                        : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                {item.tag}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}